<template>
  <div id="mail">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "mail",
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/system/mail/Mail.vue